import { useEffect } from 'react';

export const useZaloEvents = () => {
    useEffect(() => {
        const isRunningInZalo = navigator.userAgent.includes('Zalo');

        if (!isRunningInZalo) {
            return;
        }

        import('zmp-sdk/apis').then(({ events, EventName }) => {

            const handleAppPaused = () => {

            };

            events.on(EventName.AppPaused, handleAppPaused);

            return () => {
                events.off(EventName.AppPaused, handleAppPaused);
            };

        }).catch(error => {
            console.error("Zalo SDK 로드에 실패했습니다:", error);
        });

    }, []);
};